import { AlgoliaArea } from "@silversea-ssc/dotcom-read-model-types/Common";
import { Language } from "src/utils/localization/languages/types";

const ALGOLIA_ENV = process.env.GATSBY_ALGOLIA_ENV!;

//import { algoliaCruiseIndexName } from "@silversea-ssc/dotcom-api-types/AlgoliaSchema";
const algoliaCruiseIndexName = (stage: string, area: AlgoliaArea) =>
  `${stage}_cruises_${area}`;

export const cruiseSearchIndexName = (algoliaArea: AlgoliaArea) =>
  algoliaCruiseIndexName(ALGOLIA_ENV, algoliaArea);

export const globalSearchIndexName = (language: Language) =>
  `${ALGOLIA_ENV}_global_${language.code}`;
